/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import FlowForm from 'app/common/components/FlowForm';
import FormaticConfig from 'app/developer-v3/FormaticConfig';
import { setReadOnly } from 'app/developer-v3/utils';

import formFields, { TypeHookValue } from '../formFieldsLegacy';

const Styles = {
  root: css`
    & .formatic .fm-field.readonly .fm-pretty-select-input {
      &,
      &:hover {
        background-color: ${Colors.storm};
        cursor: not-allowed;
      }
    }
  `,
};

type Props = {
  hookType: TypeHookValue;
  isDisabled?: boolean;
  onChange: (value: {}) => void;
  value: {};
};

function Legacy({ hookType, isDisabled, onChange, value }: Props) {
  const typeNormalized = hookType || 'polling';

  return (
    <FlowForm
      config={FormaticConfig}
      css={Styles.root}
      fields={setReadOnly(formFields[typeNormalized], isDisabled)}
      onChange={valueNext => {
        const { type, ...rest } = valueNext;
        onChange(
          typeNormalized === 'polling' ? rest : { hookType: type, ...rest }
        );
      }}
      value={{ ...value, type: typeNormalized }}
    />
  );
}

export default Legacy;
